import { Cookie } from "@testavivadk/utilities";
import { cookieNames } from "@shared/constants/cookieNames";

export function getAuthToken(): string {
  let token = "";
  const cookie = Cookie.get(cookieNames.auth);

  if (cookie != null) {
    token = JSON.parse(cookie).token;
  }

  return token;
}

export * from "./AcceptedFileExtensions";
export * from "./lawdocs";
export { logoutUser, getInitials } from "./user";
export { getPackageProducts } from "./packageProducts";
export * from "./urls";
export { gaEvent } from "./ga4";
export { getIsProductionEnvironment, getIsStagingEnvironment } from "./applicationEnvironment";
export { getSimpleFlowRedirectUrl } from "./simpleFlow";
export {
  isDigitalProduct,
  isProductType,
  getVariantId,
  isAdviceOrReviewPurchaseType,
  isBundleProduct,
  bundleFlowStartRoutes,
} from "./products";
export { remapAdviceOrReviewDocumentStatuses, getDocumentOwnerNames } from "./documents";
export {
  captureMarketingTrackingFromUrl,
  getStoredMarketingTracking,
} from "./marketingTracking";
export { getLinePricing, getCartSubtotal } from "./cart";
export { markRouterInitialized, preloadRoute } from "./routing";
